<ig-accordion #categoryAccordion mode="dropdown"
  [title]="categoryTitle"
  class="event-date-filter"
  [menuClass]="'ig-multi-category-filter'"
  (onIconClicked)="clearCategories()"
  (onMenuOpened)="syncPendingCategories()">
  <ng-container dropdown>

    <!-- ① Locked base category (embedded) — sticky context header -->
    <div class="ig-locked-base sticky top-0 z-20" *ngIf="lockedCategoryId">
      <div class="ig-locked-main">
        <mat-icon class="ig-locked-pin">place</mat-icon>
        <span class="ig-locked-eyebrow">WITHIN</span>
        <span class="ig-locked-name" [title]="lockedCategory?.btnText">{{ lockedCategory?.btnText || 'Selected category' }}</span>
        <mat-icon class="ig-locked-lock">lock</mat-icon>
      </div>
      <p class="ig-locked-hint">
        Add filters to narrow within {{ lockedCategory?.btnText || 'this category' }}
      </p>
    </div>

    <!-- ② Editor's Choice — prominent button at the top: shows ONLY editor's choice -->
    <div class="ig-editor-choice-wrap" *ngIf="!isHideEditorChoice">
      <button type="button"
        class="ig-editor-choice-btn"
        (click)="selectEditorChoiceOnly()" igClickStopPropagation>
        <mat-icon class="ig-featured-heart">favorite</mat-icon>
        <span class="ig-editor-choice-label">{{ editorChoiceText }}</span>
      </button>
    </div>

    <!-- ③ Categories -->
    <div class="ig-cat-header">
      <span class="ig-cat-header-title">CATEGORIES</span>
      <span class="ig-cat-count" *ngIf="pendingCategoryIds.length">
        {{ pendingCategoryIds.length }} selected
      </span>
    </div>

    <!-- ALL (non-locked mode only) -->
    <button *ngIf="!lockedCategoryId" type="button"
      class="ig-cat-row" (click)="toggleAll()" igClickStopPropagation>
      <mat-checkbox class="ig-cat-cb" [checked]="pendingAll"
        (click)="$event.stopPropagation()"
        (change)="toggleAll()"></mat-checkbox>
      <span class="ig-cat-text ig-cat-text--all">ALL</span>
    </button>

    <!-- Selectable categories -->
    <button *ngFor="let category of selectableCategories" type="button"
      class="ig-cat-row" [title]="category.btnText"
      (click)="toggleCategory(category._id)" igClickStopPropagation>
      <mat-checkbox class="ig-cat-cb"
        [checked]="pendingAll || pendingCategoryIds.includes(category._id)"
        (click)="$event.stopPropagation()"
        (change)="toggleCategory(category._id)"></mat-checkbox>
      <span class="ig-cat-text">{{ category.btnText }}</span>
    </button>

    <!-- ④ Footer: sticky -->
    <div class="ig-cat-footer sticky bottom-0 z-20">
      <!-- Match All toggle (hidden in locked mode — AND is forced) -->
      <ng-container *ngIf="!lockedCategoryId">
        <button mat-menu-item (click)="toggleMatchAllCategories()"
          igClickStopPropagation class="!pl-1">
          <mat-checkbox [checked]="pendingMatchAll"
            (click)="$event.stopPropagation()"
            (change)="toggleMatchAllCategories()"></mat-checkbox>
          Match all selected types
        </button>
        <p class="text-xs text-gray-400 px-4 pb-2">
          {{ pendingMatchAll ? 'Must match ALL selected types' : 'Must match ANY selected type' }}
        </p>
      </ng-container>

      <div class="ig-confirm" igClickStopPropagation>
        <ig-button theme cls="w-full" [isAsync]="false"
          (trigger)="confirmCategorySelection()">CONFIRM</ig-button>
      </div>
    </div>
  </ng-container>
</ig-accordion>
